import { render, staticRenderFns } from "./AGPPayments.vue?vue&type=template&id=605831c1&scoped=true"
import script from "./AGPPayments.vue?vue&type=script&lang=js"
export * from "./AGPPayments.vue?vue&type=script&lang=js"
import style0 from "./AGPPayments.vue?vue&type=style&index=0&id=605831c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605831c1",
  null
  
)

export default component.exports